<section class="relative flex w-screen h-screen overflow-hidden">
  <ng-container *ngTemplateOutlet="menuSection" />
  <div class="w-full overflow-hidden h-full flex flex-col">
    <app-top-bar [header]="header()" [description]="''" />
    <div #container class="flex-1 w-full h-full overflow-y-auto bg-base-200 p-6">
      <router-outlet />
    </div>
  </div>
</section>

<ng-template #menuSection>
  <app-side-menu title="피그뱅크 관리자" logo="/icon.png" class="md:block hidden">
    <!-- 상품 정보 표시 -->
    <div class="flex flex-col p-2 gap-4">
      @if (product()) {
        <div class="flex flex-col gap-1">
          <span class="font-semibold text-gray-700 break-words">{{ product()?.name }}</span>
        </div>
        <hr class="text-zinc-300" />
      }
    </div>

    <!-- 상품 목록으로 돌아가기 -->
    <app-side-menu-item (click)="goToProductList()" [active]="false" icon="icon-[material-symbols--arrow-back]">
      상품 목록
    </app-side-menu-item>

    <!-- 메뉴 목록 -->
    @for (menu of menus; track $index) {
      <app-side-menu-item (click)="navigate(menu)" [active]="activeMenu() === menu" [icon]="menu.icon!">
        {{ menu.name }}
      </app-side-menu-item>
    }
  </app-side-menu>
</ng-template>
